
const AddQuickViewRating = () => {
  const cardWrappers = document.querySelectorAll('.card-wrapper');
  console.log(cardWrappers);
  if(cardWrappers.length > 0) {
    cardWrappers.forEach(card => {
      const ytporating = card.querySelector('.card-information__wrapper .yotpo-widget-instance');
      const quickviewBtn = card.querySelector('quick-view-button');

      if(quickviewBtn) {
        quickviewBtn.addEventListener('click', () => {
          const interval = setInterval(() => {
            const quickviewYtpo = document.querySelector('.quick-view__right .yotpo-widget-instance');

            if(quickviewYtpo) {
              clearInterval(interval);
              quickviewYtpo.innerHTML = ytporating.innerHTML
            }
          }, 1000);
        })
      }

    });
  }
}

window.addEventListener('DOMContentLoaded', AddQuickViewRating);